import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyLoadedMonogramView = loadable(() => import(/* webpackChunkName: "content/website/header/monogramview" */ './MonogramView'), 'MonogramView');
